/**
 * Core grammatical types shared by the whole Sanskrit engine.
 * Every learner-facing form carries explicit metadata built from these.
 */

export type Bi = {
    hi: string
    en: string
}

export type ExplainLang = 'hi' | 'en'

export type Gender = 'm' | 'f' | 'n'

export type Vacana = 'eka' | 'dvi' | 'bahu'

export type Purusha = 'prathama' | 'madhyama' | 'uttama'

/** 1-7 are the numbered vibhaktis, 8 is sambodhana (address). */
export type Vibhakti = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8

export type Lakara =
    | 'lat'
    | 'lrt'
    | 'lan'
    | 'lot'
    | 'vidhilin'
    | 'lit'
    | 'lut'
    | 'lun'
    | 'ashirlin'
    | 'lrn'
    | 'let'

/** Pada of a single paradigm. */
export type Pada = 'P' | 'A'

/** Pada class of a root. */
export type PadaClass = 'parasmaipada' | 'atmanepada' | 'ubhayapada'

export type Gana = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10

export type ReviewStatus = 'draft' | 'needs-review' | 'verified' | 'published' | 'archived'

export type PartOfSpeech =
    | 'noun'
    | 'pronoun'
    | 'adjective'
    | 'verb'
    | 'indeclinable'
    | 'numeral'
    | 'phrase'
    | 'participle'

export type SkillId =
    | 'devanagari'
    | 'pronunciation'
    | 'vocabulary'
    | 'reading'
    | 'listening'
    | 'speaking'
    | 'conjugation'
    | 'lakara'
    | 'verb-production'
    | 'declension'
    | 'vibhakti'
    | 'sentence'
    | 'sandhi'
    | 'comprehension'

/** A cell holds the primary form first, then any accepted variants. */
export type Cell = string[]

export type VerbTable = Record<Purusha, Record<Vacana, Cell>>

export type NounTable = Record<Vibhakti, Record<Vacana, Cell>>

export const VACANAS: Vacana[] = ['eka', 'dvi', 'bahu']

export const PURUSHAS: Purusha[] = ['prathama', 'madhyama', 'uttama']

export const VIBHAKTIS: Vibhakti[] = [1, 2, 3, 4, 5, 6, 7, 8]

export const GENDERS: Gender[] = ['m', 'f', 'n']

/** Order used when teaching: beginner lakaras first. */
export const LAKARA_ORDER: Lakara[] = ['lat', 'lrt', 'lan', 'lot', 'vidhilin', 'lit', 'lut', 'lun', 'ashirlin', 'lrn', 'let']

export const BEGINNER_LAKARAS: Lakara[] = ['lat', 'lrt', 'lan', 'lot', 'vidhilin']
